import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Now&Anon",
  "description": "",
  "published": "2006-11-28T00:00:00.000Z",
  "redirect_from": ["/blog/nowanon/swizec/348"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Wow, can you imagine how time flies when you're trying to figure out a way to shove enough hours into the day to be able to finish all of the tasks at hand by Christmas. The thing is that I've probably gotten myself in too deep, there is the very lovely paid website project that has to be done and the small manner of three paintings I decided to do as holiday presents.`}</p>
    <p>{`All in all it really adds up to the fact that the comic will be updated on time, in three days or so, and taht the news postings will go back to happening now and anon instead of anything like a schedule.`}</p>
    <p>{`Many people are unfamiliar with the idiom `}<em parentName="p">{`now and anon`}</em>{` but it's really the best bloody idiom in the whole English language. Looking at it literally it seems more as an oxy moron where `}<em parentName="p">{`now`}</em>{` means at this very point in time and `}<em parentName="p">{`anon`}</em>{` means something along the lines of right away. Put them together and what do you get? You get a phrase that means seldom ... fantastic language.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      